import { Button, ConfigProvider, Flex, Modal, notification, Space, Typography } from "antd"
import { useEffect, useState } from "react"
import { useSavedState } from "../../hooks/useSavedState"
import VSpace from "../common/VSpace"

const SynkedUPPaymentsNotification = () => {
  const [hideNotification, setHideNotification] = useSavedState<boolean>('hide-synkedup-payments-notification', false)
  const [isModalOpen, setModalOpen] = useState(false)
  const [wasNotificationShown, setNotificationShown] = useState(false)
  const [notificationApi, notificationContext] = notification.useNotification()
  const notificationKey = 'synkedup-payments-notification'

  useEffect(() => {
    if (hideNotification || wasNotificationShown) {
      return
    }

    const timeout = setTimeout(() => {
      setNotificationShown(true)
      notificationApi.open({
        key: notificationKey,
        message: <div style={{fontSize: '42px', textAlign: 'center', paddingLeft: '42px'}}>&#x1F389;</div>,
        description: <div style={{textAlign: 'center'}}>
          <p style={{fontSize: '18px'}}><strong>SynkedUP Payments Now Available</strong></p>
          <p><Typography.Text type="secondary">Create and send invoices, collect payments, and store cards on file&mdash;all inside SynkedUP.</Typography.Text></p>
          <Button type="primary" block onClick={() => {
            setModalOpen(true)
            notificationApi.destroy(notificationKey)
          }}>Learn More</Button>
        </div>,
        placement: 'bottomLeft',
        duration: null,
        onClose: () => setHideNotification(true)
      })
    }, 3000)

    return () => clearTimeout(timeout)
  }, [hideNotification, wasNotificationShown])

  return <ConfigProvider theme={{token: {colorPrimary: '#FF5C35'}}}>
    {notificationContext}
    <Modal
      open={isModalOpen}
      footer={null}
      onCancel={() => setModalOpen(false)}
      width={900}
      closeIcon={null}
    >
      <Flex gap={12}>
        <VSpace>
          <div style={{fontSize: '24px'}}><strong>Start Accepting<br/>Payments in SynkedUP</strong></div>
          <p style={{fontSize: '16px'}}>
            Invoice customers, collect payments,<br/>and keep everything in one place with SynkedUP Payments.
          </p>
          <p style={{fontSize: '16px'}}>Getting started is simple and only takes<br/>a few minutes.</p>
          <Space>
            <Button type="primary" style={{width: '160px'}} onClick={() => {
                setModalOpen(false)
                setHideNotification(true)
                window.location.href = '/#!/invoicing-settings'
              }}>
              Get Started
            </Button>
            <Button onClick={() => setModalOpen(false)}>
              Set Up Later
            </Button>
          </Space>
        </VSpace>
        <div style={{width: 640}}>
          <iframe width="500" height="282" src="https://www.loom.com/embed/158be8baa4ed4f3ca60f56f3b050e2d3" frameBorder="0" allowFullScreen></iframe>
        </div>
      </Flex>
    </Modal>
  </ConfigProvider>
}

export default SynkedUPPaymentsNotification
